import React, {PropsWithChildren} from 'react';
import {Header, Footer} from '../common/layout';
import { Outlet } from 'react-router-dom';

interface AuthLayoutPropInterface{
  isLayout?: boolean
}
export const AuthLayout: React.FC<PropsWithChildren<AuthLayoutPropInterface>> = (props) => {
  const {children, isLayout=true} = props;
  return (
    <div className='gap-4 flex flex-col grow'>
      <Header variant='auth'/>
      {/* render main content */}
      <div
        className='flex flex-col items-center px-4 py-16 h-auto grow'>
        {isLayout ? <Outlet /> : children}
      </div>

      <Footer variant='auth'/>
    </div>
  );
};